import curry from 'ramda/src/curry';
import concat from 'ramda/src/concat';
import compose from 'ramda/src/compose';

export const mediaInParens = mediaFeature => concat('(', mediaFeature, ')');

export const mediaFeaturePlain = curry(
	(name, value) => concat(name, ':', value)
);

export const minWidth = compose(
	mediaInParens,
	mediaFeaturePlain('min-width')
);

export const maxWidth = compose(
	mediaInParens,
	mediaFeaturePlain('max-width')
);
